<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'

import JoditVue from '@components/jodit/jodit-vue'
import LiquorTree from 'liquor-tree'
import Paul from 'paul'
import Multiselect from 'vue-multiselect'
import Swatches from 'vue-swatches'
import FontawesomePicker from '@components/forms/fontawesome-picker'

import NavigationApi from '@api/core/navigation'
import PageApi from '@api/cms/pages'
import ArticleApi from '@api/cms/articles'

import 'vue-swatches/dist/vue-swatches.min.css'

export default {
  page: {
    title: 'Třídy: Nová třída',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    JoditVue,
    [LiquorTree.name]: LiquorTree,
    Multiselect,
    Swatches,
    FontawesomePicker,
  },
  data() {
    return {
      id: null,
      editMode: false,
      form: {
        name: '',
        slug: '',
        description: '',
        isStatic: false,
      },
      pages: [],
      posts: [],
      menuTypes: [
        { text: 'Text', value: 0 },
        { text: 'Odkaz', value: 1 },
        { text: 'Příspěvek', value: 2 },
        { text: 'Stránka', value: 3 },
      ],
      menuItemFromSelectedPage: null,
      menuItemFromSelectedPost: null,
      menuItemForm: {
        title: '',
        url: '',
        attributes: '{}',
        description: '',
        menuItemType: 1,
        postId: null,
        pageId: null,
        background: '',
        textColor: '',
        icon: '',
      },
      node: null,

      // MENU ITEMS DATA
      data:
        this.$route.params.id != null
          ? NavigationApi.getMenuItemsByMenuId(this.$route.params.id).then(
              (response) => response.data.result
            )
          : [],
      filter: null,
      liquorMenuTreeOptions: {
        checkbox: false,
        parentSelect: true,
        dnd: true,
        propertyNames: {},
      },
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.id = this.$route.params.id
      this.editMode = this.id !== undefined

      if (this.editMode) {
        NavigationApi.getMenu(this.id)
          .then((response) => {
            this.form = response.data.result
          })
          .catch((e) => {
            console.error(e)
            this.$swal({
              title: this.L('base_result_Error'),
              text: this.L('base_info_loaditem_error'),
              icon: 'error',
            })
            this.$router.push({ name: 'settingNavigation' })
          })
          .finally(() => {
            this.init = true
          })
      }
    },
    onSubmit() {
      this.$validator.validateAll().then((result) => {
        if (!result) return

        let formData = Object.assign({}, this.form)
        let treeMenuItems = this.crateFormTreeData()
        formData.menuItems = treeMenuItems

        NavigationApi.createEditMenu(formData)
          .then(() => {
            this.$toasted.success('Menu bylo úspěšně uložena!', {
              theme: 'toasted-primary',
              position: 'bottom-right',
              duration: 5000,
            })
            this.$router.push({ name: 'settingNavigation' })
          })
          .catch((e) => {
            this.$swal({
              title: 'Nastala chyba',
              text: 'Nepodařlo se uložit menu! \n\n' + e.data.error.message,
              icon: 'error',
            })
          })
          .finally(() => {})
      })
    },
    onReset() {},

    // MENU ITEMS TREE METHODS

    handleMenuItemFormOk(evt) {
      // Prevent modal from closing
      evt.preventDefault()
      this.onMenuitemFormSubmit()
    },

    clearMenuItemForm() {},

    crateFormTreeData() {
      var tree = this.$refs.tree
      var jsonMenu = tree.toJSON()

      return this.buildMenuItemDtoFromJsonTree(jsonMenu)
    },

    buildMenuItemDtoFromJsonTree(jsonMenu) {
      var paul = new Paul(['children'])
      var jsonMenuTransformed = []

      if (jsonMenu != null) {
        jsonMenu.forEach(function(rootMenuItem) {
          jsonMenuTransformed.push(
            paul.map(rootMenuItem, (node) => {
              let nodeData = node.data
              Object.keys(nodeData).forEach(
                (key) =>
                  (nodeData[key] == null ||
                    JSON.stringify(nodeData[key]) == '{}') &&
                  delete nodeData[key]
              )
              return nodeData
            })
          )
        })
      }

      return jsonMenuTransformed
    },

    onMenuitemFormReset() {
      ;(this.menuItemForm = {
        title: '',
        url: '',
        attributes: '{}',
        description: '',
        pageId: null,
        postId: null,
        background: '',
        textColor: '',
        icon: '',
      }),
        (this.menuItemFromSelectedPage = null)
      this.menuItemFromSelectedPost = null
      this.node = null
    },

    onMenuitemFormSubmit() {
      let formData = Object.assign({}, this.menuItemForm)
      Object.keys(formData).forEach(
        (key) => formData[key] == null && delete formData[key]
      )

      formData.menuId = this.id
      formData.attributes = JSON.stringify({
        background: formData.background,
        textColor: formData.textColor,
        icon: formData.icon,
      })

      if (this.node == null) {
        this.$refs.tree.append({
          text: formData.title,
          data: formData,
        })
      } else {
        this.node.data = formData
        this.node.data.text = formData.title
      }

      this.$refs.menuItemFormModal.hide()
      this.onMenuitemFormReset()
    },

    addNode() {
      this.$refs.menuItemFormModal.show()
    },

    editNode(node, e) {
      this.$refs.menuItemFormModal.show()

      this.menuItemForm = {
        ...node.data,
        ...JSON.parse(node.data.attributes || '{}'),
      }

      if (this.menuItemForm.menuItemType == 2) {
        this.loadSelectedPost(this.menuItemForm.postId)
      }

      if (this.menuItemForm.menuItemType == 3) {
        this.loadSelectedPage(this.menuItemForm.pageId)
      }

      this.node = node
    },

    removeNode(node) {
      this.$swal({
        title: 'Varování',
        text: 'Opravdu chcete položku odebrat?',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
        buttons: ['Zrušit', 'Potrvdit smazání'],
      }).then((willDelete) => {
        if (willDelete) {
          node.remove()
        }
      })
    },

    addChildNode(node) {
      if (node.enabled()) {
        node.append({ ...this.menuItemForm, ...{ text: 'Nová položka' } })
      }
    },

    loadSelectedPage(id) {
      PageApi.get(id).then((response) => {
        var pageResult = response.data.result
        this.menuItemFromSelectedPage = {
          label: pageResult.title,
          value: pageResult.id,
        }
      })
    },

    loadSelectedPost(id) {
      ArticleApi.get(id).then((response) => {
        var postResult = response.data.result
        this.menuItemFromSelectedPost = {
          label: postResult.title,
          value: postResult.id,
        }
      })
    },

    asyncFindPages(query) {
      this.isLoading = true
      PageApi.find(query).then((response) => {
        this.pages = response.data.result
        this.isLoading = false
      })
    },

    asyncFindPosts(query) {
      this.isLoading = true
      ArticleApi.find(query).then((response) => {
        this.posts = response.data.result
        this.isLoading = false
      })
    },

    onMenuItemFormPostSelect(selectedOption, id) {
      this.menuItemForm.postId = selectedOption.value
    },

    onMenuItemFormPageSelect(selectedOption, id) {
      this.menuItemForm.pageId = selectedOption.value
    },

    parseNodeAttributes(node) {
      try {
        var o = JSON.parse(node.data.attributes)

        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) {}

      return null
    },

    getObjectProperty(object, fieldName) {
      if (object && object.hasOwnProperty(fieldName)) {
        return object[fieldName]
      } else {
        return ''
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="heading">
      <h1>Menu</h1>
      <router-link :to="{ name: 'settingNavigation' }" class="btn btn-second">zpět na seznam</router-link>
    </div>
    <div slot="tools">
      <b-button @click.prevent="onSubmit" class="btn btn-first">
        <font-awesome-icon :icon="['fas', 'save']" class="icon alt"/>Uložit
      </b-button>
    </div>

    <div class="page-content">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="pillar-title">Nové menu</h2>

            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <b-card class="md-card" no-body>
                <b-tabs card>
                  <b-tab title="Definice menu" active>
                    <div class="row">
                      <div class="col-sm-12">
                        <b-form-group class="required" label="Název" label-for="class-name">
                          <b-form-input
                            id="class-name"
                            v-model="form.name"
                            type="text"
                            required
                            placeholder
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group class="required" label="Slug" label-for="menu-slug">
                          <b-form-input
                            id="menu-slug"
                            v-model="form.slug"
                            type="text"
                            required
                            placeholder
                            :disabled="form.isStatic"
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group class label="Popisek" label-for="menu-desc">
                          <b-form-input
                            id="menu-desc"
                            v-model="form.description"
                            type="text"
                            required
                            placeholder
                          ></b-form-input>
                        </b-form-group>

                        <b-form-group
                          v-if="(editMode === false && hasPermission('StaticContent_Creating')) || (editMode === true && hasPermission('StaticContent_Editing'))"
                        >
                          <b-form-checkbox v-model="form.isStatic">Statické menu</b-form-checkbox>
                        </b-form-group>
                      </div>
                    </div>
                  </b-tab>
                  <b-tab title="Položky menu">
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="menu-items-tree">
                          <div>
                            <button
                              @click.prevent="addNode"
                              class="btn btn-primary"
                            >Přidat položku menu</button>
                          </div>
                          <tree
                            :data="data"
                            :options="liquorMenuTreeOptions"
                            :filter="filter"
                            ref="tree"
                          >
                            <div slot-scope="{ node }" class="node-container">
                              <div class="node-text">{{ node.text }}</div>
                              <div class="node-props">
                                <div
                                  class="menu-attr-bg"
                                  :style="{ backgroundColor: getObjectProperty(parseNodeAttributes(node),'background') }"
                                ></div>
                              </div>
                              <div class="node-controls">
                                <a class="btn btn-xs" href="#" @mouseup.stop="editNode(node)">
                                  <i class="fas fa-edit"></i>
                                </a>
                                <a class="btn btn-xs" href="#" @mouseup.stop="removeNode(node)">
                                  <i class="far fa-trash-alt" style="color: red;"></i>
                                </a>
                                <a class="btn btn-xs" href="#" @mouseup.stop="addChildNode(node)">
                                  <i class="far fa-plus-square"></i>
                                </a>
                              </div>
                            </div>
                          </tree>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
              </b-card>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <!-- Menu item modal -->
    <b-modal
      no-close-on-backdrop
      @hidden="onMenuitemFormReset"
      size="lg"
      ref="menuItemFormModal"
      id="menu-item-modal"
      title="Editace položky menu"
      @ok="handleMenuItemFormOk"
      @shown="clearMenuItemForm"
    >
      <b-form @submit.prevent="onMenuitemFormSubmit" @reset="onMenuitemFormReset">
        <b-form-group class label="Typ položky menu" label-for="menuItem-title">
          <b-form-select v-model="menuItemForm.menuItemType" :options="menuTypes"></b-form-select>
        </b-form-group>

        <b-form-group class="required" label="Titulek" label-for="menuItem-title">
          <b-form-input
            id="menuItem-title"
            v-model="menuItemForm.title"
            type="text"
            required
            placeholder
          ></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="menuItemForm.menuItemType == 1 || menuItemForm.menuItemType == 0"
          class
          label="URL"
          label-for="menuItem-utl"
        >
          <b-form-input
            id="menuItem-utl"
            v-model="menuItemForm.url"
            type="text"
            required
            :disabled="menuItemForm.menuItemType == 0"
            placeholder="#"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          v-if="menuItemForm.menuItemType == 2"
          label="Příspěvek"
          label-for="menuItem-desc"
        >
          <multiselect
            v-model="menuItemFromSelectedPost"
            :options="posts"
            :multiple="false"
            :searchable="true"
            @search-change="asyncFindPosts"
            @select="onMenuItemFormPostSelect"
            track-by="value"
            label="label"
            placeholder="Vyhledat článek podle titulku..."
            name="prispevek"
          ></multiselect>
        </b-form-group>

        <b-form-group
          v-if="menuItemForm.menuItemType == 3"
          label="Stránka"
          label-for="menuItem-desc"
        >
          <multiselect
            v-model="menuItemFromSelectedPage"
            :options="pages"
            :searchable="true"
            @search-change="asyncFindPages"
            @select="onMenuItemFormPageSelect"
            :multiple="false"
            track-by="value"
            label="label"
            placeholder="Vyhledat stránku podle názvu..."
            name="stranka"
          ></multiselect>
        </b-form-group>

        <b-form-group class label="Popisek" label-for="menuItem-desc">
          <b-form-input
            id="menuItem-desc"
            v-model="menuItemForm.description"
            type="text"
            placeholder
          ></b-form-input>
        </b-form-group>

        <div class="row">
          <div class="col">
            <div class="form__field">
              <div class="form__label">Pozadí odkazu:</div>
              <div class="form__input">
                <swatches
                  v-model="menuItemForm.background"
                  show-fallback
                  swatch-size="30"
                  :max-height="300"
                  popover-to="left"
                ></swatches>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="form__field">
              <div class="form__label">Barva textu:</div>
              <div class="form__input">
                <swatches v-model="menuItemForm.textColor" colors="text-advanced" popover-to="left"></swatches>
              </div>
            </div>
          </div>
        </div>

        <b-form-group label="Ikonka" label-for="menuItem-icon">
          <!-- <fontawesome-picker v-model="selectedFontAwesomeIcon"></fontawesome-picker> -->

          <b-form-input
            id="menuItem-icon"
            v-model="menuItemForm.icon"
            type="text"
            placeholder="Zde napište název ikonky"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
.node-props {
  flex: 1;
}

.menu-attr-bg {
  float: right;
  width: 10px;
  height: 10px;
  margin-top: 15px;
  margin-right: 20px;
}

.vue-swatches__wrapper {
  box-sizing: content-box;
}

.vue-swatches__container {
  line-height: initial;
}

.form__field {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-align: center;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

div.tree-content {
  margin: 0;
  margin-top: 2px;
  margin-bottom: 2px;
  border: 1px solid #fff;
  vertical-align: middle;
  padding: 5px 10px 5px 0;
  background: url('~@assets/images/bg.png');
  background-repeat: no-repeat;
  background-position: -20px 0;
  // padding-left: 14px !important;
  line-height: 32px;
}

div.tree-content:hover {
  background: url('~@assets/images/bg.png') !important;
  background-repeat: no-repeat !important;
  background-position: -20px -100px !important;
  border-color: #2cafe3;
  background-color: #d1e8ff;
}

.node-container {
  width: 100%;
  display: flex;

  .node-text {
    line-height: 38px;
  }

  .node-controls {
    margin-left: auto;
  }
}

.tree-arrow.has-child {
  margin-left: 20px;
}

.tree-arrow {
  flex-shrink: 0;
  height: 30px;
  cursor: pointer;
  margin-left: 50px;
  width: 0;
}
</style>
